import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import '../VoucherPDFStyles.css';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
  render() {
    const voucherData = this.props.voucherData;
    const selectedSearchValues = this.props.searchData;

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div
          style={{
            fontFamily: 'sans-serif',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center', 
            textAlign: 'center', 
          }}
        >
          <div className=" row-top-gap">
            <div style={{ fontSize: "14px" }}>
              <p style={{ paddingBottom: '3px' }}>{selectedSearchValues.groupName}</p>
                        <p style={{ paddingBottom: '3px' }}>{(selectedSearchValues.factoryName).toUpperCase()} - {voucherData.routeName}</p>
              <p style={{ fontSize: "12px" }}>MAIN CASH PAYMENT VOUCHER</p>
            </div>
            <Grid container style={{ fontSize: "14px", justifyContent: 'center', paddingTop: '30px' }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div className="col" align={"left"} style={{ paddingBottom: "50px" }}>
                    <p>Payee</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div className="col" align={"left"} style={{ paddingBottom: "50px" }}>
                    <p>{voucherData.customerName + "(" + voucherData.registrationNumber + ")"}</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>B/L Advance for
                      {voucherData.yearMonth.length !== 0 ? (" " + moment(voucherData.yearMonth[0].applicableMonth).format('MMMM')) : ""}
                      {voucherData.yearMonth.length !== 0 ? (voucherData.yearMonth.length === 2 ? (" / " + (moment(voucherData.yearMonth[1].applicableMonth).format('MMMM'))) : "") : ""}
                    </p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>V : NO</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>Date</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>CHQ No</p>
                  </div>
                </Grid>

                <Grid xs={6}>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>{(voucherData.voucherDetails).length === 0 ? "" : voucherData.voucherDetails[0].referenceNumber}</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>{(voucherData.issuingDate).split('T')[0]}</p>
                  </div>
                  <div className="col" align={"left"} style={{ paddingBottom: "7px" }}>
                    <p>{(voucherData.voucherDetails).length === 0 ? "" : voucherData.voucherDetails[0].voucherNumber}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <div>&nbsp;</div>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Account Description</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {voucherData.voucherDetails.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.ledgerAccountCode}
                        </TableCell>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.description}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.debit !== 0 ? data.debit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): ''}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', borderRight: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.credit !== 0 ? data.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {voucherData.totalDebit === undefined ? "" : (voucherData.totalDebit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {voucherData.totalCredit === undefined ? "" : (voucherData.totalCredit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            <div align={"left"} style={{ fontSize: "14px", paddingBottom: '35px' }}>
              <p>I do hereby certify that I have received Sum of Rupees <b>{voucherData.totalCredit === undefined ? "" : (voucherData.totalCredit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> Only as detailed above from the management of {selectedSearchValues.factoryName}.</p>
            </div>
            <div style={{ fontSize: "14px" }} align={"right"}>
              -------------------------------
            </div>
            <div style={{ paddingBottom: "8px", fontSize: "14px" }} align={"right"}>
              Signature of Receipient
            </div>
            &nbsp;&nbsp;
            <Grid container style={{ fontSize: '14px', paddingTop: '20px', paddingRight:'90px' }}>
              <Grid item xs={4} align='center'>
                <div style={{ minHeight: '14px' }}>
                  {voucherData.preparedBy == null || voucherData.preparedBy == "" ? "" : voucherData.preparedBy}
                </div>
                <div className="row" align={"center"}>
                  -------------------------------
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div style={{ minHeight: '14px' }}>
                  {voucherData.checkedBy == null || voucherData.checkedBy == "" ? "" : voucherData.checkedBy}
                </div>
                <div className="row" align={"center"}>
                -------------------------------
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div style={{ minHeight: '14px' }}>
                  {voucherData.checkedBy == null || voucherData.checkedBy == "" ? "" : voucherData.checkedBy}
                </div>
                <div className="row" align={"center"}>
                -------------------------------
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div className="row" align={"center"}>
                </div>
              </Grid>
            </Grid>
            <Grid container style={{ fontSize: '14px', paddingRight:'90px' }}>
              <Grid item xs={4} align='center'>
                <div className="row" align={"center"}>
                  Prepared By
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div className="row" align={"center"}>
                  Checked By
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div className="row" align={"center"}>
                  Approved By
                </div>
              </Grid>
              <Grid item xs={4} align='center'>
                <div className="row" align={"center"}>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Paper>
    );
  }
}
